import React, { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import { HiMinus } from "react-icons/hi";
import { useWindowContext } from "../Context/WindowContext";

const PageWindow = ({ window, index }) => {
  const { closeWindow, minimizeWindow } = useWindowContext();
  const [purchaseOrderHeaderTarget, setPurchaseOrderHeaderTarget] = useState(null);

  useEffect(() => {
    const target = Array.from(document.querySelectorAll(".page-window-mode-tabs"))
      .find((element) => element.dataset.windowId === String(window.id));

    setPurchaseOrderHeaderTarget(target || null);
  }, [window.id]);

  const pageContent = React.isValidElement(window.content)
    ? React.cloneElement(window.content, {
      windowId: window.id,
      purchaseOrderHeaderTarget
    })
    : window.content;

  return (
    <div className="page-window" style={{ marginTop: index * 12 }}>
      <div className="page-window-header">

        <div className="window-left">
          <div className="window-icon">
            {window.icon}
          </div>

          <div className="window-info">
            <span className="window-title">
              {window.title}
            </span>

            <span className="window-subtitle">
              Enterprise Resource Planning
            </span>
          </div>
        </div>

        <div
          className="page-window-mode-tabs"
          data-window-id={window.id}
        />

        <div className="window-actions">
          <button
            className="window-action-btn"
            onClick={() => minimizeWindow(window.id)}
            title="Minimize"
          >
            <HiMinus size={24} />
          </button>

          <button
            className="window-action-btn close"
            onClick={() => closeWindow(window.id)}
            title="Close"
          >
            <FaTimes />
          </button>
        </div>

      </div>

      <div className="page-window-body">
        {pageContent}
      </div>
    </div>
  );
};

export default PageWindow;